import { DocumentNode, gql } from '@apollo/client'

export const CREATE_DAYCARE: DocumentNode = gql`
    mutation CreateDaycare(
        $name: String!
        $phone: Phone!
        $type: DaycareType!
        $manager: String!
        $email: Email!
        $address: String!
        $zip: String!
        $city: String!
        $country: String!
        $monOpen: Time
        $monClose: Time
        $monBreakStart: Time
        $monBreakEnd: Time
        $tueOpen: Time
        $tueClose: Time
        $tueBreakStart: Time
        $tueBreakEnd: Time
        $wedOpen: Time
        $wedClose: Time
        $wedBreakStart: Time
        $wedBreakEnd: Time
        $thuOpen: Time
        $thuClose: Time
        $thuBreakStart: Time
        $thuBreakEnd: Time
        $friOpen: Time
        $friClose: Time
        $friBreakStart: Time
        $friBreakEnd: Time
        $satOpen: Time
        $satClose: Time
        $satBreakStart: Time
        $satBreakEnd: Time
        $sunOpen: Time
        $sunClose: Time
        $sunBreakStart: Time
        $sunBreakEnd: Time
        $timezone: String
    ) {
        createDaycare(
            daycare: {
                name: $name
                phone: $phone
                type: $type
                manager: $manager
                email: $email
                address: $address
                zip: $zip
                city: $city
                country: $country
            }
            opening: {
                monOpen: $monOpen
                monClose: $monClose
                monBreakStart: $monBreakStart
                monBreakEnd: $monBreakEnd
                tueOpen: $tueOpen
                tueClose: $tueClose
                tueBreakStart: $tueBreakStart
                tueBreakEnd: $tueBreakEnd
                wedOpen: $wedOpen
                wedClose: $wedClose
                wedBreakStart: $wedBreakStart
                wedBreakEnd: $wedBreakEnd
                thuOpen: $thuOpen
                thuClose: $thuClose
                thuBreakStart: $thuBreakStart
                thuBreakEnd: $thuBreakEnd
                friOpen: $friOpen
                friClose: $friClose
                friBreakStart: $friBreakStart
                friBreakEnd: $friBreakEnd
                satOpen: $satOpen
                satClose: $satClose
                satBreakStart: $satBreakStart
                satBreakEnd: $satBreakEnd
                sunOpen: $sunOpen
                sunClose: $sunClose
                sunBreakStart: $sunBreakStart
                sunBreakEnd: $sunBreakEnd
            }
            timezone: $timezone
        )
    }
`

export const GET_DAYCARE: DocumentNode = gql`
    query GetDaycare($daycare_id: Int!) {
        getDaycare(daycare_id: $daycare_id) {
            id
            active
            staffAccess
            type
            name
            manager
            email
            phone
            address
            city
            zip
            country
            bookMin
            bookWeeklyLimit
            bookRange
            autoLink
            autoLinkEnable
            internalAutoLink
            internalAutoLinkEnable
            externalAutoLink
            externalAutoLinkEnable
            trusteeWrite
            merger
            created
            updated
            validityEnd
            timezone
            activeAlert
            alertRange
            alertComment
            mailSignature
            staffCount
            expirationDuration
            newsAccess
            limitByWeek
            limitOfSlot
            exceedLimit
            suggestAccess
            taskNoteAccess
            mealAccess
            annuaireId
            colors {
                daycareDark
                daycareMain
                daycareLight
                daycareExtraLight
                parentDark
                parentMain
                parentLight
                parentExtraLight
            }
            logoBase64Data
            accessibility {
                id
                type
                start
                end
            }
            staffLink {
                notifReport
                notifNewParent
                notifPushNewParent
                notifUpdateParent
                notifPushUpdateParent
                notifNewStaff
                notifPushNewStaff
                notifConfirmation
                notifPushConfirmation
                notifCancellation
                notifPushCancellation
                notifRequestSlot
                notifPushRequestSlot
                notifEventDays
                notifPushEventDays
                notifRegularSlot
                notifPushRegularSlot
                notifTaskNote
                notifPushTaskNote
                level
                rw_params_daycare
                rw_staffs
                rw_staff_work
                rw_families
                rw_child
                rw_occasional_slot
                rw_request_slot
                rw_regular_slot
                rw_news
                rw_event_days
                rw_closing_days
                w_add_posts
                rw_suggestions
                rw_task_note
                rw_meal
            }
            opening {
                monOpen
                monClose
                monBreakStart
                monBreakEnd
                tueOpen
                tueClose
                tueBreakStart
                tueBreakEnd
                wedOpen
                wedClose
                wedBreakStart
                wedBreakEnd
                thuOpen
                thuClose
                thuBreakStart
                thuBreakEnd
                friOpen
                friClose
                friBreakStart
                friBreakEnd
                satOpen
                satClose
                satBreakStart
                satBreakEnd
                sunOpen
                sunClose
                sunBreakStart
                sunBreakEnd
            }
            groups {
                id
                name
            }
            sections {
                id
                max
                name
                sectionGroupId
            }
            sectionsGroups {
                id
                name
                sections
                rate
            }
            levels {
                id
                name
                required
            }
            predefinedMessages {
                type
                message
            }
            releaseParameters {
                releaseActivation
                releaseWeekCountBefore
                releaseDayCountBefore
                releaseDay
                releaseHour
            }
            haveDaycareGroup
        }
    }
`

export const GET_DAYCARE_LIST: DocumentNode = gql`
    query GetDaycareList {
        getDaycareList {
            id
            active
            staffAccess
            type
            name
            manager
            email
            phone
            address
            city
            zip
            country
            bookMin
            bookWeeklyLimit
            bookRange
            autoLink
            autoLinkEnable
            internalAutoLink
            internalAutoLinkEnable
            externalAutoLink
            externalAutoLinkEnable
            trusteeWrite
            merger
            created
            updated
            validityEnd
            timezone
            activeAlert
            alertRange
            alertComment
            mailSignature
            staffCount
            expirationDuration
            newsAccess
            limitByWeek
            limitOfSlot
            exceedLimit
            suggestAccess
            taskNoteAccess
            mealAccess
            annuaireId
            colors {
                daycareDark
                daycareMain
                daycareLight
                daycareExtraLight
                parentDark
                parentMain
                parentLight
                parentExtraLight
            }
            logoBase64Data
            accessibility {
                id
                type
                start
                end
            }
            staffLink {
                notifReport
                notifNewParent
                notifPushNewParent
                notifUpdateParent
                notifPushUpdateParent
                notifNewStaff
                notifPushNewStaff
                notifConfirmation
                notifPushConfirmation
                notifCancellation
                notifPushCancellation
                notifRequestSlot
                notifPushRequestSlot
                notifEventDays
                notifPushEventDays
                notifRegularSlot
                notifPushRegularSlot
                notifTaskNote
                notifPushTaskNote
                level
                rw_params_daycare
                rw_staffs
                rw_staff_work
                rw_families
                rw_child
                rw_occasional_slot
                rw_request_slot
                rw_regular_slot
                rw_news
                rw_event_days
                rw_closing_days
                w_add_posts
                rw_suggestions
                rw_task_note
                rw_meal
            }
            opening {
                monOpen
                monClose
                monBreakStart
                monBreakEnd
                tueOpen
                tueClose
                tueBreakStart
                tueBreakEnd
                wedOpen
                wedClose
                wedBreakStart
                wedBreakEnd
                thuOpen
                thuClose
                thuBreakStart
                thuBreakEnd
                friOpen
                friClose
                friBreakStart
                friBreakEnd
                satOpen
                satClose
                satBreakStart
                satBreakEnd
                sunOpen
                sunClose
                sunBreakStart
                sunBreakEnd
            }
            groups {
                id
                name
            }
            sections {
                id
                max
                name
                sectionGroupId
            }
            sectionsGroups {
                id
                name
                sections
                rate
            }
            levels {
                id
                name
                required
            }
            predefinedMessages {
                type
                message
            }
            releaseParameters {
                releaseActivation
                releaseWeekCountBefore
                releaseDayCountBefore
                releaseDay
                releaseHour
            }
            haveDaycareGroup
        }
    }
`

export const GET_DAYCARE_WITHOUT_FAMILY: DocumentNode = gql`
    query GetDaycareWithoutFamily {
        getDaycareWithoutFamily
    }
`

export const GET_DAYCARE_WITHOUT_SLOTS: DocumentNode = gql`
    query GetDaycareWithoutSlots {
        getDaycareWithoutSlots
    }
`

export const GET_DAYCARE_WITHOUT_SLOTS_2_MONTHS: DocumentNode = gql`
    query GetDaycareWithoutSlots2Months {
        getDaycareWithoutSlots2Months
    }
`

export const UPDATE_DAYCARE: DocumentNode = gql`
    mutation UpdateDaycare(
        $daycare_id: Int!
        $name: String!
        $type: DaycareType!
        $phone: Phone!
        $manager: String!
        $email: Email!
        $address: String!
        $zip: String!
        $city: String!
        $country: String!
    ) {
        updateDaycare(
            daycare_id: $daycare_id
            daycare: {
                name: $name
                phone: $phone
                type: $type
                manager: $manager
                email: $email
                address: $address
                zip: $zip
                city: $city
                country: $country
            }
        )
    }
`

export const UPDATE_DAYCARE_OPENING: DocumentNode = gql`
    mutation UpdateDaycareOpening(
        $daycare_id: Int!
        $monOpen: Time
        $monClose: Time
        $monBreakStart: Time
        $monBreakEnd: Time
        $tueOpen: Time
        $tueClose: Time
        $tueBreakStart: Time
        $tueBreakEnd: Time
        $wedOpen: Time
        $wedClose: Time
        $wedBreakStart: Time
        $wedBreakEnd: Time
        $thuOpen: Time
        $thuClose: Time
        $thuBreakStart: Time
        $thuBreakEnd: Time
        $friOpen: Time
        $friClose: Time
        $friBreakStart: Time
        $friBreakEnd: Time
        $satOpen: Time
        $satClose: Time
        $satBreakStart: Time
        $satBreakEnd: Time
        $sunOpen: Time
        $sunClose: Time
        $sunBreakStart: Time
        $sunBreakEnd: Time
    ) {
        updateDaycareOpening(
            daycare_id: $daycare_id
            opening: {
                monOpen: $monOpen
                monClose: $monClose
                monBreakStart: $monBreakStart
                monBreakEnd: $monBreakEnd
                tueOpen: $tueOpen
                tueClose: $tueClose
                tueBreakStart: $tueBreakStart
                tueBreakEnd: $tueBreakEnd
                wedOpen: $wedOpen
                wedClose: $wedClose
                wedBreakStart: $wedBreakStart
                wedBreakEnd: $wedBreakEnd
                thuOpen: $thuOpen
                thuClose: $thuClose
                thuBreakStart: $thuBreakStart
                thuBreakEnd: $thuBreakEnd
                friOpen: $friOpen
                friClose: $friClose
                friBreakStart: $friBreakStart
                friBreakEnd: $friBreakEnd
                satOpen: $satOpen
                satClose: $satClose
                satBreakStart: $satBreakStart
                satBreakEnd: $satBreakEnd
                sunOpen: $sunOpen
                sunClose: $sunClose
                sunBreakStart: $sunBreakStart
                sunBreakEnd: $sunBreakEnd
            }
        )
    }
`

export const SET_DAYCARE_TIMEZONE: DocumentNode = gql`
    mutation SetDaycareTimezone($daycare_id: Int!, $timezone: String!) {
        setDaycareTimezone(daycare_id: $daycare_id, timezone: $timezone)
    }
`

export const CHANGE_MIN_SLOT: DocumentNode = gql`
    mutation ChangeMinSlot($daycareId: Int!, $range: BookRange, $bookMin: Int, $bookWeeklyLimit: Int) {
        changeMinSlot(daycare_id: $daycareId, range: $range, book_weekly_limit: $bookWeeklyLimit, book_min: $bookMin)
    }
`

export const CHANGE_NO_MERGER_PARAMETERS: DocumentNode = gql`
    mutation ChangeNoMergerParameters(
        $daycareId: Int!
        $limitByWeek: Int!
        $limitOfSlot: Int!
        $exceedLimit: Boolean!
    ) {
        changeNoMergerParameters(
            daycareId: $daycareId
            limitByWeek: $limitByWeek
            limitOfSlot: $limitOfSlot
            exceedLimit: $exceedLimit
        )
    }
`

export const SET_ALERT: DocumentNode = gql`
    mutation SetAlert($daycareId: Int!, $active: Boolean!, $range: AlertRange!, $comment: String!) {
        setAlert(daycare_id: $daycareId, active_alert: $active, alert_range: $range, alert_comment: $comment)
    }
`

export const SET_VALIDITY_END: DocumentNode = gql`
    mutation SetValidityEnd($daycareId: Int!, $date: Date!) {
        setValidityEnd(daycare_id: $daycareId, date: $date)
    }
`

export const SET_MAIL_SIGNATURE: DocumentNode = gql`
    mutation SetMailSignature($daycareId: Int!, $signature: String!) {
        setMailSignature(daycare_id: $daycareId, signature: $signature)
    }
`

export const GET_PLACES: DocumentNode = gql`
    query GetOccasionalSlotsPlaces($daycareId: Int!) {
        getOccasionalSlotsPlaces(daycareId: $daycareId) {
            id
            name
            address
        }
    }
`

export const CREATE_PLACE: DocumentNode = gql`
    mutation CreateOccasionalSlotsPlaces($daycareId: Int!, $name: String!, $address: String!) {
        createOccasionalSlotsPlaces(daycareId: $daycareId, name: $name, address: $address)
    }
`

export const UPDATE_PLACE: DocumentNode = gql`
    mutation UpdateOccasionalSlotsPlaces($daycareId: Int!, $placeId: Int!, $name: String, $address: String) {
        updateOccasionalSlotsPlaces(daycareId: $daycareId, placeId: $placeId, name: $name, address: $address)
    }
`

export const DELETE_PLACE: DocumentNode = gql`
    mutation DeleteOccasionalSlotsPlaces($daycareId: Int!, $placeId: Int!) {
        deleteOccasionalSlotsPlaces(daycareId: $daycareId, placeId: $placeId)
    }
`

export const GET_ALL_REQUESTS: DocumentNode = gql`
    query GetAllRequest($daycareId: Int!) {
        getAllRequests(daycareId: $daycareId)
    }
`

export const GET_PLANNING_INFO: DocumentNode = gql`
    query GetPlanningInfo($daycareId: Int!) {
        getPlanningInfo(daycareId: $daycareId) {
            lastOccasionalSlot
            lastRegularSlot
            lastPost
            lastEvent
            lastStaffWork
            lastConnectionDate
        }
    }
`

export const SET_PREDEFINED_MESSAGE: DocumentNode = gql`
    mutation SetPredefinedMessage($daycareId: Int!, $type: PredefinedMessageType!, $message: String!) {
        setPredefinedMessage(daycareId: $daycareId, type: $type, message: $message)
    }
`

export const SET_OTHER_RESERVATION_PARAMETERS: DocumentNode = gql`
    mutation SetOtherReservationParameters(
        $daycareId: Int!
        $expirationDuration: ExpirationDuration
        $releaseActivation: ReleaseActivation
        $releaseWeekCountBefore: Int
        $releaseDayCountBefore: Int
        $releaseHour: Time
        $releaseDay: Int
    ) {
        setOtherReservationParameters(
            daycareId: $daycareId
            expirationDuration: $expirationDuration
            releaseActivation: $releaseActivation
            releaseWeekCountBefore: $releaseWeekCountBefore
            releaseDayCountBefore: $releaseDayCountBefore
            releaseHour: $releaseHour
            releaseDay: $releaseDay
        )
    }
`
